import { NetworkStatus } from '@cbridge-utils/network';
import { IAdjustmentProfileStore } from './adjustmentProfile.interface';

export const adjustmentProfileInitialState: IAdjustmentProfileStore = {
  data: {},
  defaultData: {
    priceMultiplier: undefined,
    volumeMultiplier: undefined,
  },
  networkStatus: NetworkStatus.None,
};
